<template>
    <div class="company-dropdown">
        <vue-select
            v-model="internalValue"
            :options="options"
            :label="usedLabelField"
            :reduce="reduceFn"
            :clearable="clearable"
            :placeholder="placeholder"
            :disabled="disabled || isLoading"
        />
    </div>
</template>

<script>
import { handleRequests } from '@/helpers';

export default {
    name: 'TeamMemberCompanyDropdownFilter',
    props: {
        value: { type: [String, Number, Object, null], default: null },
        placeholder: { type: String, default: 'Select company' },
        clearable: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        labelField: { type: String, default: 'name' },
        reduce: { type: Function, default: null },
        includeAll: { type: Boolean, default: false },
        allLabel: { type: String, default: 'All Companies' }
    },
    data() {
        return {
            isLoading: false,
            internalValue: null,
            companies: []
        };
    },
    computed: {
        options() {
            if (this.includeAll) {
                return [{ name: this.allLabel, isAll: true }, ...this.companies];
            }
            return this.companies;
        },
        usedLabelField() {
            if (this.options.length > 0) {
                const sample = this.options[0];
                if ('companyName' in sample) 
                    return 'companyName';
                if ('name' in sample) 
                    return 'name';
                if ('company' in sample) 
                    return 'company';
            }
            return this.labelField;
        },
        reduceFn() {
            if (this.reduce) 
                return this.reduce;
            // Return null for the All option (isAll) so no companyName param is sent.
            return (item) => {
                if (!item) 
                    return null;
                if (item.isAll) 
                    return null; // All Companies => no filter
                // Return a primitive string (company name)
                return item.name || item.companyName || item.company || null;
            };
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(v) {
                this.internalValue = v;
            }
        },
        internalValue(v) {
            // v is already null for All due to reduceFn; just emit through
            this.$emit('input', v || null);
            this.$emit('change', v || null);
        }
    },
    methods: {
        async fetchCompanies() {
            if (this.isLoading) 
                return;
            this.isLoading = true;
            try {
                const { data } = await handleRequests('/api/teams/companies');
                this.companies = Array.isArray(data)
                    ? data
                        .filter((c) => c && (c.name || c.companyName || c.company))
                        .map((c) => ({ name: c.name || c.companyName || c.company }))
                    : [];
            } catch (e) {
                this.companies = [];
            } finally {
                this.isLoading = false;
            }
        }
    },
    mounted() {
        this.fetchCompanies();
    }
};
</script>

<style scoped>
.company-dropdown {
    width: 100%;
}
.company-dropdown .vs__dropdown-toggle {
    min-height: 38px;
}
</style>
